var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTpnumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6387 0.333313C13.0884 0.333313 14.2637 1.50857 14.2637 2.95831V21.0416C14.2637 22.4913 13.0884 23.6666 11.6387 23.6666H2.88867C1.43893 23.6666 0.263672 22.4913 0.263672 21.0416V2.95831C0.263672 1.50857 1.43893 0.333313 2.88867 0.333313H11.6387ZM8.722 19H5.80534C5.3221 19 4.93034 19.3917 4.93034 19.875C4.93034 20.3582 5.3221 20.75 5.80534 20.75H8.722C9.20524 20.75 9.597 20.3582 9.597 19.875C9.597 19.3917 9.20524 19 8.722 19Z",
    fill: "#ABB1BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpnumber);
export default __webpack_public_path__ + "static/media/tpnumber.10ee85bb563eaa254a0680f6da2910b4.svg";
export { ForwardRef as ReactComponent };